<section class="auth-page">
  <div class="auth-card">
    <h1>Create Account</h1>
    <p class="sub">
      @if (step === 'details') {
        Start building document sign templates.
      } @else {
        Verify your email to complete signup.
      }
    </p>

    @if (step === 'details') {
      <label for="name">Name</label>
      <input id="name" type="text" [(ngModel)]="name" autocomplete="name" />
      @if (fieldErrors.name) {
        <p class="field-error">{{ fieldErrors.name }}</p>
      }

      <label for="email">Email</label>
      <input id="email" type="email" [(ngModel)]="email" autocomplete="email" />
      @if (fieldErrors.email) {
        <p class="field-error">{{ fieldErrors.email }}</p>
      }

      <label for="password">Password</label>
      <input id="password" type="password" [(ngModel)]="password" autocomplete="new-password" />
      @if (fieldErrors.password) {
        <p class="field-error">{{ fieldErrors.password }}</p>
      }

      <button type="button" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Creating…' : 'Create Account' }}
      </button>
    } @else {
      <p class="meta">A 6-digit OTP was sent to {{ emailMasked || email }}.</p>
      <p class="meta">OTP expires at: {{ otpExpiresAt }}</p>

      <label for="otp">Enter OTP</label>
      <input id="otp" type="text" [(ngModel)]="otp" maxlength="6" autocomplete="one-time-code" />
      @if (fieldErrors.otp) {
        <p class="field-error">{{ fieldErrors.otp }}</p>
      }

      <button type="button" (click)="verifyOtp()" [disabled]="loading">
        {{ loading ? 'Verifying…' : 'Verify OTP' }}
      </button>
      <button type="button" class="secondary" (click)="resendOtp()" [disabled]="loading">
        {{ loading ? 'Sending…' : 'Resend OTP' }}
      </button>
      @if (remainingResends !== null) {
        <p class="meta">Remaining resends: {{ remainingResends }}</p>
      }
    }

    @if (errorMessage) {
      <p class="error">{{ errorMessage }}</p>
    }

    <p class="switch">Already have an account? <a routerLink="/login">Sign in</a></p>
  </div>
</section>
